var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Hero',{attrs:{"title":_vm.$t('HERO_MESSAGE_MARKETING'),"description":_vm.$t('HERO_CAROUSEL_HEADER_MARKETING')}}),_c('MarketingView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }